import router from '@/router'
import {
  getTerminalMenu
} from '@api'
export default {
  state: {
    //菜单集合
    menuList: null,
    //自定义菜单集合
    customMenuList: null,
    //选中的一级菜单
    activeOne: null,
    //选中的二级菜单
    activeTwo: null,
    //菜单宽度折叠
    collapsed: false,
    //预览菜单下标
    previewMenuIndex: null,
    //展示浮动菜单
    floatVisibel: false,
    //全局层级模块设置
    overAllModuleSetting: [],
    //用户层级模块设置
    userModuleSetting: [],
  },
  mutations: {
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setActiveOne(state, activeOne) {
      state.activeOne = activeOne
    },
    setActiveTwo(state, activeTwo) {
      // 如果存在预览一级菜单 则选中
      if (state.previewMenuIndex != null) {
        this.commit('setActiveOne', state.menuList[state.previewMenuIndex])
      }
      state.activeTwo = activeTwo
    },
    setCollapsed(state, collapsed) {
      state.collapsed = collapsed
    },
    setFloatVisibel(state, previewMenuIndex) {
      if (!previewMenuIndex && previewMenuIndex != 0) {
        //关闭
        state.floatVisibel = false
        //延迟取消预览
        setTimeout(() => {
          state.previewMenuIndex = null
        }, 300)
        return
      }
      //打开
      state.previewMenuIndex = previewMenuIndex
      state.floatVisibel = true
    },
    setOverAllModuleSetting(state, overAllModuleSetting) {
      state.overAllModuleSetting = overAllModuleSetting
    },
    setUserModuleSetting(state, userModuleSetting) {
      state.userModuleSetting = userModuleSetting
    }
  },
  actions: {
    /** 打开记录的一级菜单 目前默认打开第一个 */
    openRecordMenu({ state, dispatch }) {
      this.commit('setCollapsed', false)
      dispatch('openOneMenu', { oneMenu: state.menuList[0] })
    },
    /** 打开一级菜单 */
    openOneMenu({ state, commit }, { oneMenu, index }) {
      if (state.collapsed) {
        //折叠菜单 展示预览子目录
        commit('setFloatVisibel', index)
        return
      }
      //没有折叠菜单 
      commit('setActiveOne', oneMenu)
      //跳转路由
      router.push({
        name: oneMenu.name
      })
    },
    async refreshTerminalMenu() {
      let overAllData = null
      let userData = null
      overAllData = await getTerminalMenu({ type: 'OVERALL' })
      userData = await getTerminalMenu({ type: 'USER' })
      this.commit('setOverAllModuleSetting', overAllData.data)
      this.commit('setUserModuleSetting', userData.data)
    }
  },
  getters: {
    // 获取菜单
    getMenuList(state, getters) {
      console.log('state.authMenuList', state.authMenuList)
      return authMenuListHandler(state.menuList, getters.getAuthMenuList)
    },
    // 二级菜单列表
    getTwoMenus(state) {
      return state.activeOne?.children || []
    },
    // 选中二级菜单标识
    getActiveTwoName(state) {
      return state.activeTwo?.name
    },
    //获取全局层级模块设置
    getOverAllMoudleSetting(state) {
      return state.overAllModuleSetting
    },
    //获取用户层级模块设置
    getUserModuleSetting(state) {
      return state.userModuleSetting
    },
    // 根据指定的模块类型返回二级菜单列表
    getTwoMenusByModuleType:(state, getters)=>(userInfo)=>{
      if(!userInfo)return[]
      let menu = getters.getTwoMenus
      let usedModuleSetting = null
      let moduleType=getters.getUsedModuleType(userInfo)
      // console.log(`当前获取模块:${moduleType}`)
      switch (moduleType) {
        case "USER":
        case null:
          usedModuleSetting = JSON.parse(JSON.stringify(getters.getUserModuleSetting))
          break
        case "OVERALL":
          usedModuleSetting = JSON.parse(JSON.stringify(getters.getOverAllMoudleSetting))
          break
        default:
          throw new Error("未知的模块类型！")
      }
      if (!(usedModuleSetting.btnList)) return menu
      usedModuleSetting.btnList.forEach(item => {
        let target = menu.find(item2 =>
          item.code === item2.name
        )
        if (!target) return
        target.enable = item.enable
        target.title = item.btnName
      });
      return menu
    },
    //根据用户信息和本地模块类型获取应调用的模块设置
    getUsedModuleType:()=>(userInfo)=> {
      if(!userInfo)return "null"
      // console.log(`根据用户类型判断为:${userInfo.userType.name}`)
      let usedModuleType = null
      switch (userInfo.userType.name) {
        case "后台用户":
          usedModuleType = "USER"
          break
        case "管理员":
          usedModuleType ="OVERALL"
          break
        default:
          throw new Error("未知的用户状态！")
      }
      return usedModuleType
    },
  },
}

/**
 * 授权菜单处理
 * @param {*} defMenuList 定义菜单
 * @param {*} authMenuList 授权列表
 * @returns 
 */
function authMenuListHandler(defMenuList, authMenuList) {
  let menuList = []
  defMenuList.forEach(menu => {
    //非固定菜单并且没有授权
    if (!menu.fixed && authMenuList.indexOf(menu.name) == -1) {
      return
    }
    //如果有子级 递归处理子级
    if (menu.children) {
      menu.children = authMenuListHandler(menu.children, authMenuList)
    }
    menuList.push(menu)
  })
  return menuList
}